import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { badgesPageActions } from './badges.page.actions';
import { Feature, FeatureService } from '@fitup-monorepo/core/lib/services/features/feature.service';

export const badgesGuard: CanActivateFn = () => {
  const store = inject(Store);

  store.dispatch(badgesPageActions.loadEarnedBadges());

  return true;
};

export const badgesFeatureGuard: CanActivateFn = async () => {
  const featureService = inject(FeatureService);

  return featureService.isVisible(Feature.badges);
};
